import { createAction } from '@reduxjs/toolkit';
import { ListingModel, PartnerListingModel } from './ListingModels';
import { ListingsActionTypes } from './ListingsActionTypes';

export const postListingAction = createAction<ListingModel>(ListingsActionTypes.POST_LISTING);

export const putListingAction = createAction(
  ListingsActionTypes.PUT_LISTING,
  (listingId: string, listing: ListingModel) => {
    return {
      payload: {
        listingId,
        listing,
      },
    };
  },
);

export const getListingAction = createAction<string>(ListingsActionTypes.GET_LISTING);

export const getPartnerListingAction = createAction<string>(ListingsActionTypes.GET_PARTNER_LISTING);

export const getListingsAction = createAction(
  ListingsActionTypes.GET_LISTINGS,
  (
    lat: string,
    lng: string,
    type: string,
    people: string,
    radius: string,
    objectTypes: string,
    objectCharacteristics: string,
    offerFeatures: string,
    leaseOnly: string,
  ) => {
    return {
      payload: {
        lat,
        lng,
        people,
        type,
        radius,
        objectTypes,
        objectCharacteristics,
        offerFeatures,
        leaseOnly,
      },
    };
  },
);
export const storeListingsAction = createAction<ListingModel[]>(ListingsActionTypes.STORE_LISTINGS);
export const storePartnerListingsAction = createAction<PartnerListingModel[]>(
  ListingsActionTypes.STORE_PARTNER_LISTINGS,
);
export const storeListingAction = createAction<ListingModel>(ListingsActionTypes.STORE_LISTING);

export const loadingListingsAction = createAction<boolean>(ListingsActionTypes.LOADING_LISTINGS);
